/**Import react section */
import React, { useState } from 'react'

/**Import Material Ui section */
import { Grid } from '@material-ui/core'

/**Import components section */
import TextBox from '../../common/TextBox'
import ButtonSaved from '../../common/Buttons/ButtonSaved'
import TimeLineCommentHistory from './TimeLineCommentHistory'
import { isNullOrEmpty } from '../../../store/helpers/StringHelper'

const CommentHistoryComponent = (props) => {
	/**objects section*/
	const { service } = props
	/**Functions sections*/
	const { onAddCommentHistory, onUpdateCommentHistory, onUpdateComment, onDownloadHistoryCommnets } = props

	/**bool props section */
	const { isSavingService, isAuthorizedForCreatingComment, isAuthorizedForChangingStatus } = props
	const [comments, setComments] = useState('')
	const onCommentHistoryAdd = (event) => {
		event.stopPropagation()
		if (onAddCommentHistory) {
			onAddCommentHistory(service, comments)
		}
	}

	const canBeSaved = () => {
		if (isNullOrEmpty(comments)) return false
		return true
	}

	/**On change properties */
	const onCommentsChange = (event) => {
		setComments(event.target.value)
	}
	return (
		<Grid container>
			{isAuthorizedForCreatingComment && (
				<Grid item xs={12}>
					<br />
					<TextBox
						active={true}
						fullWidth
						name='comments'
						variant='outlined'
						margin='dense'
						label='COMMENTS'
						multiline
						rows={3}
						autoFocus
						onChange={onCommentsChange}
						value={comments ? comments : ''}
						disabled={!isAuthorizedForCreatingComment}
					/>
				</Grid>
			)}
			<Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
				{isAuthorizedForCreatingComment && (
					<ButtonSaved title='Add' onSavedClick={onCommentHistoryAdd} isSaving={isSavingService || !canBeSaved()} />
				)}
				<div style={{ marginLeft: '5px' }}>
					<ButtonSaved title='Download comments' isSaving={isSavingService} onSavedClick={onDownloadHistoryCommnets} />
				</div>
			</Grid>

			<Grid item xs={12}>
				<TimeLineCommentHistory
					commentsHistory={props.service ? props.service.CommentsHistories : []}
					serviceToken={props.service.Token}
					onUpdateCommentHistory={onUpdateCommentHistory}
					onUpdateComment={onUpdateComment}
					isAuthorizedForChangingStatus={isAuthorizedForChangingStatus}
					isAuthorizedForCreatingComment={isAuthorizedForCreatingComment}
				/>
			</Grid>
		</Grid>
	)
}

export default CommentHistoryComponent
